import { render, staticRenderFns } from "./addphone.html?vue&type=template&id=2860f504&scoped=true&"
import script from "./addphone.js?vue&type=script&lang=js&"
export * from "./addphone.js?vue&type=script&lang=js&"
import style0 from "./addphone.sass?vue&type=style&index=0&id=2860f504&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860f504",
  null
  
)

component.options.__file = "addphone.vue"
export default component.exports